import axios from 'axios';

// ======================== Configuration ========================
const BASE_URL = 'https://loyalty.bom.asia';

// ======================== Loading Screen Functions ========================

/**
 * Lấy tất cả Loading Screen Images
 */
export const fetchLoadingScreen = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/api/image/imageLoadingSceen`);
    return response.data.images || [];
  } catch (error) {
    console.error('Error fetching loading screen:', error);
    throw error.response?.data || { message: 'Failed to fetch loading screen' };
  }
};

/**
 * Upload Loading Screen Image
 */
export const fetchUploadImageScreen = async (file, time) => {
  try {
    const formData = new FormData();
    formData.append('url', file);
    formData.append('time', time);

    const response = await axios.post(`${BASE_URL}/api/image/imageLoadingSceen`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data.image;
  } catch (error) {
    console.error('Error uploading image:', error);
    throw error.response?.data || { message: 'Failed to upload image' };
  }
};

/**
 * Sửa Loading Screen Image
 */
export const fetchEditImageScreen = async (id, formData) => {
  try {
    const response = await axios.put(`${BASE_URL}/api/image/imageLoadingSceen/${id}`, formData);
    return response.data.image;
  } catch (error) {
    console.error('Error editing image:', error);
    throw error.response?.data || { message: 'Failed to edit image' };
  }
};

/**
 * Xóa Loading Screen Image
 */
export const fetchDeleteImageScreen = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL}/api/image/imageLoadingSceen/${id}`);
    return { id, ...response.data };
  } catch (error) {
    console.error('Error deleting image:', error);
    throw error.response?.data || { message: 'Failed to delete image' };
  }
};

// ======================== Default Export ========================
export default {
  fetchLoadingScreen,
  fetchUploadImageScreen,
  fetchEditImageScreen,
  fetchDeleteImageScreen,
};

